import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=66f72d36&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
import style0 from "./icon.vue?vue&type=style&index=0&id=66f72d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f72d36",
  null
  
)

export default component.exports